import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth, arrowWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track12BBlue = ({ state, workState, onLabelClick }) => (
	<g id="Track12BBlue" transform="translate(2140.000000, 124.000000)" className="track">
		<g id="line" transform="translate(0.477024, 0.000000)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<path
				d="M58.8926817,32.563158 L34.5111676,73.0398602 C25.9853524,87.1938984 21.0997078,103.240036 20.2910126,119.743743 L16.8116295,190.750361 C16.2732084,201.73836 17.5516092,212.739903 20.5953154,223.311652 L29.0206385,252.57545 C36.2150946,277.564059 24.1163804,304.066471 0.522975656,315 L0.522975656,315 L0.522975656,315"/>

			<TrackArrow transform="translate(65.781923, 21.157208) rotate(-61.000000) translate(-65.781923, -21.157208) "
									points="69.7819233 29.1572079 61.7819233 21.1572079 69.7819233 13.1572079"/>
			<path
				d="M146.022976,11.921875 L119.409329,52.9319945 C118.335189,54.587183 116.496152,55.5860794 114.522976,55.5860794 L114.522976,55.5860794 L114.522976,55.5860794 M114.522976,55.5860794 C111.442792,55.5860794 106.80057,52.9679721 104.754354,44.5760185 L97.3469464,8.3874577 C96.3476503,3.5054415 92.0520014,0 87.068762,0 C81.755926,0 76.831222,2.78268788 74.0898999,7.33366353 L64.7385387,22.858223"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track12BBlue')}
			coords="0.000000, 154.000000"
			text='12B'
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

Track12BBlue.propTypes = trackPropTypes;

export default Track12BBlue;
